import { UilDollarAlt, UilFileCheckAlt, UilBill, UilAwardAlt } from '@iconscout/react-unicons';

import { Menu } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';

import UilEllipsisV from '@iconscout/react-unicons/icons/uil-ellipsis-v';
import propTypes from 'prop-types';

function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
  };
}

const itemsByRole = (toggleCollapsed, path, topMenu) => {
  const items = [
    getItem(
      <NavLink onClick={toggleCollapsed} to={`${path}/`}>
        แทงหวย
      </NavLink>,
      'main',
      !topMenu && (
        <NavLink className="menuItem-iocn" to={`${path}/`}>
          <UilDollarAlt />
        </NavLink>
      ),
    ),
    // getItem(
    //   <NavLink onClick={toggleCollapsed} to={`${path}/rule`}>
    //     กฎและกติกา
    //   </NavLink>,
    //   'rule',
    //   !topMenu && (
    //     <NavLink className="menuItem-iocn" to={`${path}/rule`}>
    //       <UilClipboardNotes />
    //     </NavLink>
    //   ),
    // ),
    getItem(
      <NavLink onClick={toggleCollapsed} to={`${path}/bet-report`}>
        รายการแทง
      </NavLink>,
      'bet-report',
      !topMenu && (
        <NavLink className="menuItem-iocn" to={`${path}/bet-report`}>
          <UilFileCheckAlt />
        </NavLink>
      ),
    ),
    getItem(
      <NavLink onClick={toggleCollapsed} to={`${path}/result`}>
        บัญชีการเงิน
      </NavLink>,
      'result',
      !topMenu && (
        <NavLink className="menuItem-iocn" to={`${path}/result`}>
          <UilBill />
        </NavLink>
      ),
    ),
    getItem(
      <NavLink onClick={toggleCollapsed} to={`${path}/lotto-result`}>
        ตรวจสอบผลรางวัล
      </NavLink>,
      'lotto-result',
      !topMenu && (
        <NavLink className="menuItem-iocn" to={`${path}/lotto-result`}>
          <UilAwardAlt />
        </NavLink>
      ),
    ),
  ];

  return items;
}

function MenuItems({ toggleCollapsed }) {

  const { topMenu } = useSelector((state) => {
    return {
      topMenu: state.ThemeLayout.topMenu,
    };
  });

  const path = '/system';
  const pathName = window.location.pathname;
  const pathArray = pathName && pathName !== '/' ? pathName.split(path) : [];
  const mainPath = pathArray.length > 1 ? pathArray[1] : '';
  const mainPathSplit = mainPath.split('/');

  const [openKeys, setOpenKeys] = React.useState(
    !topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'dashboard'}`] : [],
  );

  const onOpenChange = (keys) => {
    setOpenKeys(keys[keys.length - 1] !== 'recharts' ? [keys.length && keys[keys.length - 1]] : keys);
  };

  const onClick = (item) => {
    if (item.keyPath.length === 1) setOpenKeys([]);
  };

  const items = itemsByRole(toggleCollapsed, path, topMenu);

  return (
    <Menu
      onOpenChange={onOpenChange}
      onClick={onClick}
      mode={!topMenu || window.innerWidth <= 991 ? 'inline' : 'horizontal'}
      // // eslint-disable-next-line no-nested-ternary
      defaultSelectedKeys={
        !topMenu
          ? [
            `${mainPathSplit.length === 1 ? 'home' : mainPathSplit.length === 2 ? mainPathSplit[1] : mainPathSplit[2]
            }`,
          ]
          : []
      }
      defaultOpenKeys={!topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'dashboard'}`] : []}
      overflowedIndicator={<UilEllipsisV />}
      openKeys={openKeys}
      items={items}
    />
  );
}

MenuItems.propTypes = {
  toggleCollapsed: propTypes.func,
};

export default MenuItems;
